// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1j06D","question":"Question_question__3XurI","description":"Question_description__2vp0C"};